import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Homepage from '../HomePage5/HomePage';
import AboutPage from '../AboutPage/AboutPage';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import Search from '../Search/Search';
import ShopPage from '../ShopPage/ShopPage'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import VideoPage from '../../components/VideoPage/VideoPage';
import ProductGroupPage from '../ProductGroupPage/ProductGroupPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import PopupQuickview from '../../components/PopupQuickview/PopupQuickview';

// Admin Pages
import AdminLogin from '../../admin/pages/AdminLogin';
import AdminDashboard from '../../admin/pages/AdminDashboard';
import AdminProducts from '../../admin/pages/AdminProducts';
import AdminUsers from '../../admin/pages/AdminUsers';
import AdminOrders from '../../admin/pages/AdminOrders';
import AdminMessages from '../../admin/pages/AdminMessages';
import AdminSettings from '../../admin/pages/AdminSettings';

// Protected Route Component
const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem('adminToken');
  return isAuthenticated ? element : <Navigate to="/admin/login" replace />;
};



const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="service" element={<ServicePages />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path='shop-single/:slug' element={<PopupQuickview />} />
          <Route path="ProductGroupPage" element={<ProductGroupPage />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='404' element={<ErrorPage />} /> 
          <Route path="Video/:slug" element={<VideoPage />} />
          <Route path='/products/:category' element={<ShopPage/>} />
          <Route path='/products' element={<ShopPage/>} />
          <Route path="/search" element={<Search />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute element={<AdminDashboard />} />} />
          <Route path="/admin/products" element={<ProtectedRoute element={<AdminProducts />} />} />
          <Route path="/admin/users" element={<ProtectedRoute element={<AdminUsers />} />} />
          <Route path="/admin/orders" element={<ProtectedRoute element={<AdminOrders />} />} />
          <Route path="/admin/messages" element={<ProtectedRoute element={<AdminMessages />} />} />
          <Route path="/admin/settings" element={<ProtectedRoute element={<AdminSettings />} />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
